import { render, staticRenderFns } from "./View.vue?vue&type=template&id=61e0fe1b&scoped=true&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"
import style0 from "../../style.css?vue&type=style&index=0&id=61e0fe1b&prod&scoped=true&lang=css&"
import style1 from "./View.vue?vue&type=style&index=1&id=61e0fe1b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e0fe1b",
  null
  
)

export default component.exports